export default {
  R: "#00639a",
  N: "#00639a",
  D: "#00639a",
  Q: "#00639a",
  E: "#00639a",
  G: "#00639a",
  H: "#00639a",
  K: "#00639a",
  S: "#00639a",
  T: "#00639a",
  Y: "#00639a",
};
